import { CheckinEntryUpdate, S3CheckinEntry } from '../app/types'

export function mergeEntryUpdates(
  data: S3CheckinEntry[],
  updates: CheckinEntryUpdate[]
): S3CheckinEntry[] {
  const entriesMap = data.reduce((map, entry) => {
    map.set(entry.entry_id, entry)
    return map
  }, new Map())
  const updatesMap = updates.reduce((map, update) => {
    map.set(update.entryId, update)
    return map
  }, new Map())

  return Array.from(entriesMap.values()).map(entry => {
    const update = updatesMap.get(entry.entry_id)
    if (update) {
      return {
        ...entry,
        entry_bib: update.bib,
        entry_tag: update.tag,
        entry_check_in: update.checkedIn ? 1 : 0,
        entry_check_in_time: update.checkInTime ?? null,
      }
    }

    return entry
  })
}
